import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const PanelContactUs = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding10rem1 right-padding10rem1 py-md5 py4'>
        <div className='left-padding8rem right-padding8rem py-md-5 py-5'>
            <div className='py-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)'}}>
                <div className='fs-ss-20 text-montserrat fw-600 text-ss-black lh-1-2 px-md-5'>
                    <center>
                        You can always count on<span className='text-ss-primary'> United Lab Care</span> for reliable lab tests. Our team is prepared to handle whatever you require!
                    <hr className='hr-style my-md-2 mt-2 mt-md-0' style={{ width:'130px', marginTop:'2px', marginBottom:'4px'}}/>
                    </center>
                </div>

                <div className='py-3'>
                <center>
                <Link to='/contact'>
                <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                    <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                        Contact Us
                    </text>
                </Button>
                </Link>
                </center>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default PanelContactUs